import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Layout from './hoc/layout';
import Home from './components/home/home';
import Login from './containers/login/login';
import Feedback from './containers/feedback/feedback';
import MotivationFeedback from './containers/feedback/feedback-motivection';
import Measurements from './containers/measurements/measurements';
import Users from './containers/users/users';
import FreeUser from './containers/users/freeUser';
import Trainer from './containers/users/trainer';
import Numbers from './containers/numbers/numbers';
import Workouts from './containers/workouts/workouts';
import Skills from './containers/workouts/skills';
import WorkoutsVideos from './containers/workouts/workoutsVideos';
import Exercises from './containers/workouts/exercise';
import Logout from './containers/login/logout';
import Auth from './hoc/auth';
import Dataset from './containers/dataset/dataset';
import Plan from './containers/workouts/plan';

const Routes = () => {
    return (
        <Layout>
            <Switch>
                <Route path="/" exact component={Auth(Home,true)}/>
                <Route path="/login" exact component={Auth(Login, false)}/>
                <Route path="/users" exact component={Auth(Users,true)}/>
                <Route path="/updateUser" exact component={Auth(FreeUser,true)}/>
                <Route path="/trainer" exact component={Auth(Trainer,true)}/>
                <Route path="/feedback" exact component={Auth(Feedback,true)}/>
                <Route path="/motivationFeedback" exact component={Auth(MotivationFeedback,true)}/>
                <Route path="/workout" exact component={Auth(Workouts,true)}/>
                <Route path="/skills" exact component={Auth(Skills,true)}/>
                <Route path="/workoutVideos" exact component={Auth(WorkoutsVideos,true)}/>
                <Route path="/exercise" exact component={Auth(Exercises,true)}/>
                <Route path="/measurements" exact component={Auth(Measurements,true)}/>
                <Route path="/numbers" exact component={Auth(Numbers,true)}/>
                <Route path="/dataset" exact component={Auth(Dataset, true)}/>
                <Route path="/plan" exact component={Auth(Plan, true)}/>
                <Route path="/logout" exact component={Auth(Logout,true)}/>
            </Switch>
        </Layout>
    );
};

export default Routes;